import React from "react";

import { MeetingModelJson, WorkspaceModelJson } from "@performyard/service-contracts";

import Pagination from "../../../../components/Pagination";
import Spacer from "../../../../components/Spacer";

import MeetingAccordion from "./Meetings/MeetingAccordion";

interface WorkspaceDetailsMeetingListProps {
	meetings: MeetingModelJson[];
	workspace: WorkspaceModelJson;
	expandedMeetingIds: string[];
	handleToggleAccordion: (meetingId: string) => void;
	userId: string;
	totalMeetingsCount: number;
	pageNumber: number;
	setPageNumber: (page: number) => void;
	pageSize: number;
	isAdmin?: boolean;
	setEditingMeeting?: (meeting: MeetingModelJson | null) => void;
	setUserAssignment?: (
		assignment: {
			actionItemId: string;
			meetingId: string;
			currentAssigneeId?: string;
			dueDate?: Date | null;
			name?: string;
		} | null
	) => void;
}

const WorkspaceDetailsMeetingList = ({
	meetings,
	workspace,
	expandedMeetingIds,
	handleToggleAccordion,
	userId,
	totalMeetingsCount,
	pageNumber,
	setPageNumber,
	pageSize,
	isAdmin = false,
	setEditingMeeting = () => {},
	setUserAssignment = () => {},
}: WorkspaceDetailsMeetingListProps) => {
	const meetingAccordions = (
		<div className="space-y-4">
			{meetings.map((meeting) => (
				<MeetingAccordion
					key={meeting._id}
					meeting={meeting}
					workspace={workspace}
					expandedMeetingIds={expandedMeetingIds}
					handleToggleAccordion={handleToggleAccordion}
					userId={userId}
					setEditingMeeting={setEditingMeeting}
					setUserAssignment={setUserAssignment}
					isAdminView={isAdmin}
				/>
			))}
		</div>
	);

	return (
		<>
			{meetingAccordions}
			{totalMeetingsCount > pageSize && (
				<>
					<Spacer height={3} />
					<Pagination
						currentPage={pageNumber}
						pageCount={Math.ceil(totalMeetingsCount / pageSize)}
						onClick={(page: number) => setPageNumber(page)}
					/>
				</>
			)}
		</>
	);
};

export default WorkspaceDetailsMeetingList;
